module.exports = __webpack_public_path__ + "img/hitogata_gray.ad4ab6d8.png";